export default __webpack_public_path__ + "static/media/front-end.102b7f6c.png";